<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-08 17:38:24
 * @LastEditors: HG
 * @LastEditTime: 2019-08-13 16:20:07
 -->
<template>
  <div class="container">
    <head-nav-bar title="住院费用汇总" :fixed="true" />
    <div class="mt-header-nav">
      <detaile-head :info="info" />
      <div class="kong"></div>
      <!-- <list-head-date-picker v-model="totalDate" @change="onDateChange" /> -->
      <DataList api="InHospital_List" :params="listParams">
        <template v-slot:item="item">
          <van-cell is-link @click="toInfo(item.obj)">
            <div slot="title">
              <div>
                <span>{{ item.obj.costDate }}</span>
              </div>
            </div>
            <div class="value">
              {{ item.obj.amount }}
            </div>

            <van-icon
              slot="right-icon"
              name="arrow"
              style="line-height: 0.65rem;"
            />
          </van-cell>
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import { Button, Cell, Icon } from "vant";
// import ListHeadDatePicker from "@/components/ListHeadDatePicker";
import DataList from "@/components/DataList";
import { formatDate } from "@/utils/common";
import DetaileHead from "./DetailedHead";

export default {
  name: "Confirm",
  components: {
    DataList,
    DetaileHead,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Icon.name]: Icon
  },
  computed: {},
  data() {
    return {
      DiagnosisCardNo: "",
      InpatientId: "",
      InDate: "",
      info: {},
      tabActive: "",
      totalDate: formatDate(),
      detaileDate: formatDate(),
      listParams: { DiagnosisCardNo: 0, InpatientId: 0, InDate: 0 }
    };
  },
  created() {
    this.DiagnosisCardNo = this.$route.query.DiagnosisCardNo;
    this.InpatientId = this.$route.query.InpatientId;
    this.InDate = this.$route.query.InDate;
    this.listParams.DiagnosisCardNo = this.DiagnosisCardNo;
    this.listParams.InpatientId = this.InpatientId;
    this.listParams.InDate = this.InDate;
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$post("InHospital_Info", {
        DiagnosisCardNo: this.DiagnosisCardNo
      }).then(res => {
        this.info = res.data;
      });
    },
    toInfo(item) {
      this.$router.push({
        name: "userInHospitalDetailedInfo",
        query: {
          diagnosisCardNo: this.DiagnosisCardNo,
          inpatientId: this.InpatientId,
          costDate: item.costDate
        }
      });
    },
    onDateChange(date) {
      console.log(date);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.cell-item {
  .title {
    width: 70px;
    margin-right: 0;
  }
}
</style>
